export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Registro eletrônico de hóspedes — Polizia di Stato (Itália)",

  fields: {
    utente: "Utente",
    password: "Password",
    wskey: "WsKey",
    wskeyHint: "A WsKey é gerada no portal alloggiatiweb.poliziadistato.it → Gestione dispositivi.",
    tipoStruttura: "Tipo de acomodação",
    idAppartamento: "ID do apartamento",
    idAppartamentoHint: "ID do apartamento registrado no Alloggiati Web.",
    keepBlank: "(deixe em branco para manter o valor atual)",
  },

  tipoOptions: {
    hotel: "Hotel / B&B / Casa de temporada",
    appartamento: "Apartamento gerenciado",
  },

  actions: {
    saveAndVerify: "Salvar e verificar",
    updateCredentials: "Atualizar credenciais",
    verifyConnection: "Verificar conexão",
    saving: "Salvando...",
    verifying: "Verificando...",
  },

  status: {
    connectionOk: "Credenciais salvas e conexão verificada com sucesso.",
    connectionError: "Erro de conexão. Verifique as credenciais informadas.",
    connectionPending: "Conexão ainda não verificada. Clique em \"Verificar conexão\" para confirmar.",
  },

  validation: {
    utenteRequired: "O campo Utente é obrigatório.",
    passwordRequired: "A senha é obrigatória.",
    wskeyRequired: "A WsKey é obrigatória.",
    idAppartamentoRequired: "O ID do apartamento é obrigatório.",
  },

  toasts: {
    saveSuccess: "Credenciais salvas e conexão verificada com sucesso.",
    saveWarning: "Credenciais salvas, mas não foi possível verificar a conexão.",
    saveError: "Não foi possível salvar as credenciais.",
    testSuccess: "Conexão com o Alloggiati Web verificada com sucesso.",
    testError: "Não foi possível verificar a conexão.",
    statusActive: "Alloggiati Web ativado.",
    statusInactive: "Alloggiati Web desativado.",
  },
};